import { TripAdjustmentResponse } from 'guest-data-types-ts-lib/types';
import { CurrencyUtils, TranslationUtils } from '../../utils';
import React from 'react';
import { ReceiptLineSummary } from './ReceiptLineSummary';

interface ReceiptLineOccupancyProps {
    preview: TripAdjustmentResponse;
    locale: string;
}

export const ReceiptLinePoolHeatAdjustment: React.FC<ReceiptLineOccupancyProps> = (props) => {
    const { preview, locale } = props;
    const { delta } = preview;
    const text = TranslationUtils.get('pool_heat_capitalized');

    return (
        <>
            <ReceiptLineSummary
                summaryTitle={text}
                summaryValue={CurrencyUtils.formatCurrency(delta.fees, delta.currency)}
                currency={delta.currency}
                locale={locale}
            />
            <hr className={'detail-separator'} />
        </>
    );
};
